import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";
import Grid from "../../components/Grid";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { Show } from "../../hooks/Show";
import { useAuth } from "../../hooks/useAuth";
import Select from "../../components/AppSelect";

const Headquarters = ({
  reduxGetCities,
  cities,
  reduxGetHeadquarters,
  headquarters,
  reduxGetHeadquarter,
  headquarter,
  reduxPostHeadquarters,
  rowEdited,
  reduxDeleteHeadquarters,
  rowDeleted,
  reduxPatchHeadquarters,
  rowUpdated,
  reduxResetHeadquartersForm,
  reduxGetCompanies,
  companies,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
    getValues
  } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const { session } = useAuth();
  const [show, setShow] = useState(false);

  const handleClose = () => {
    reduxResetHeadquartersForm();
    setShow(false);
  };
  const handleShow = () => {
    reduxGetCities({
      page: 1,
      search: "",
      offset: 100000,
    });
    reduxGetCompanies({
      page: 1,
      search: "",
      offset: 1000,
    });
    reduxResetHeadquartersForm();
    reset();
    setShow(true);
  };
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData.idHeadquarters}</span>;
      },
      field: 'idHeadquarters',
      searchable: true
    },
    {
      title: "Nombre",
      render: (rowData) => {
        return <span>{rowData.nameHeadquarters}</span>;
      },
      field: 'nameHeadquarters',
      searchable: true
    },
    {
      title: "Descripción",
      render: (rowData) => {
        return <span>{rowData.description}</span>;
      },
      field: 'description',
      searchable: true
    },
    {
      title: "Ciudad",
      render: (rowData) => {
        return <span>{rowData.city.description}</span>;
      },
      field: 'city.description',
      searchable: true
    },
    {
      title: "Empresa",
      render: (rowData) => {
        return (
          <span>
            {rowData.company != null ? rowData.company.description : ""}
          </span>
        );
      },
      field: 'company.description',
      searchable: true
    },
    {
      title: "Opciones",
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-headquarters">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleOpen(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-headquarters">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-headquarters">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
          </>
        );
      },
    },
  ];

  const handleOpen = (row) => {
    reduxGetCities({
      page: 1,
      search: "",
      offset: 100000,
    });
    reduxGetCompanies({
      page: 1,
      search: "",
      offset: 1000,
    });
    reduxGetHeadquarter({
      id: row.idHeadquarters,
    });
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteHeadquarters(row);
    }
  };

  useEffect(() => {
    if (rowEdited && cities && Object.keys(cities).length > 0) {
      const [companySelected] = rowEdited.idCompany ? companies.items.filter((f) => f.idCompany === rowEdited.idCompany) : [{idCompany: null, description: "Seleccionar"}]
      
      setShow(true);
      setValue("nameHeadquarters", rowEdited.nameHeadquarters);
      setValue("description", rowEdited.description);
      setValue("idCity", { value: rowEdited.idCity, label: rowEdited.city.description });
      setValue("idCompany", {value: companySelected.idCompany, label: companySelected.description});
    }
  }, [rowEdited, cities]);

  const handleDelete = (row) => {
    reduxDeleteHeadquarters(row);
  };

  useEffect(() => {
    reduxGetHeadquarters({
      page: 1,
      offset: offset,
      search: "",
    });
  }, []);

  useEffect(() => {
    reduxGetHeadquarters({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage]);

  const onSubmit = (data) => {
    if (rowEdited) {
      reduxPatchHeadquarters({ ...data, id: rowEdited.idHeadquarters });
    } else {
      reduxPostHeadquarters(data);
    }
    reset();
    reduxResetHeadquartersForm();
    setShow(false);
  };

  useEffect(() => {
    if (headquarter || rowUpdated || rowDeleted) {
      reduxGetHeadquarters({
        page: currentPage,
        offset: offset,
        search: search,
      });
      reduxResetHeadquartersForm();
    }
  }, [headquarter, rowUpdated, rowDeleted]);

  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">Sedes</h1>
                <Show when="feature:create-headquarters">
                  <button
                    className="btn btn-primary btn-circle"
                    type="button"
                    onClick={handleShow}
                  >
                    <i className="fas fa-plus fa-sm"></i>
                  </button>
                </Show>
              </div>
              <p className="mb-4">Módulo de Administración de sedes</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Listado de Sedes
                  </h6>
                </div>
                <div className="card-body">
                  <Grid
                    cols={columns}
                    data={
                      headquarters && Object.keys(headquarters).length > 0
                        ? headquarters.items
                        : []
                    }
                    page={
                      headquarters && Object.keys(headquarters).length > 0
                        ? Number(headquarters.page)
                        : currentPage
                    }
                    pages={
                      headquarters && Object.keys(headquarters).length > 0
                        ? Number(headquarters.totalPages)
                        : 0
                    }
                    total={
                      headquarters && headquarters.hasOwnProperty("total")
                        ? headquarters.total
                        : 0
                    }
                    offset={offset}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRange={(value) => {
                      setOffset(value);
                      reduxGetHeadquarters({
                        page: 1,
                        offset: value,
                        search: search,
                      });
                    }}
                    defaultValue={search}
                    onChangeSearch={(value) => {
                      setSearch(value);
                      reduxGetHeadquarters({
                        page: 1,
                        offset: offset,
                        search: value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          onEscapeKeyDown={handleClose}
          backdrop="static"
          keyboard={true}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title>{rowEdited ? "Editar" : "Nueva"} Sede</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label htmlFor="nameHeadquarters" className="form-label">
                  Nombre
                </label>
                <input
                  id="nameHeadquarters"
                  type="text"
                  className={`form-control form-control-user ${
                    errors.nameHeadquarters && "is-invalid"
                  }`}
                  {...register("nameHeadquarters", { required: true })}
                />
                {errors.nameHeadquarters && (
                  <span className="invalid-feedback">
                    El nombre es requerido
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="description" className="form-label">
                  Descripción
                </label>
                <input
                  id="description"
                  type="text"
                  className={`form-control form-control-user ${
                    errors.description && "is-invalid"
                  }`}
                  {...register("description", { required: true })}
                />
                {errors.description && (
                  <span className="invalid-feedback">
                    La descripción es requerida
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="idCity" className="form-label">
                  Ciudad
                </label>
                
                
                <Select
                  isClearable={true}
                  value={getValues('idCity')}
                  {...register('idCity', { required: true })}
                  id='idCity'
                  onChange={(value) => setValue('idCity', value?.value || '')}
                  options=
                  {cities &&
                    Object.keys(cities).length > 0 &&
                    cities.items
                      .map((ele) => ({                                    
                          value: ele.idCity,
                          label: ele.description,
                        }))
                  }
                />
                {errors.idCity && (
                  <span className="invalid-feedback">
                    La ciudad es requerida
                  </span>
                )}
              </div>
              {session && session.role.idCompany == null && (
                <div className="form-group">
                  <label htmlFor="idCompany" className="form-label">
                    Empresa
                  </label>  
                <Select
                  isClearable={true}
                  {...register('idCompany', { required: true })}
                  value={getValues('idCompany')}
                  id='idCompany'
                  onChange={(value) => setValue('idCompany', value?.value || '')}
                  options=
                  {companies &&
                    Object.keys(companies).length > 0 &&
                    companies.items
                    .filter((f) => f.isActive == true)
                    .map((ele) => ({                                    
                          value: ele.idCompany,
                          label: ele.description,
                        }))
                  }
                />
                  {errors.idCompany && (
                    <span className="invalid-feedback">
                      La empresa es requerida
                    </span>
                  )}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Guardar
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cities: state.cityState.cities,
    headquarters: state.headquartersState.headquarters,
    headquarter: state.headquartersState.headquarter,
    rowEdited: state.headquartersState.rowEdited,
    rowDeleted: state.headquartersState.rowDeleted,
    rowUpdated: state.headquartersState.rowUpdated,
    companies: state.companyState.companies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetCities: (payload) =>
      dispatch({
        type: "FETCH_CITIES_REQUEST",
        value: payload,
      }),
    reduxGetCompanies: (payload) =>
      dispatch({
        type: "FETCH_COMPANIES_REQUEST",
        value: payload,
      }),
    reduxGetHeadquarters: (payload) =>
      dispatch({
        type: "FETCH_HEADQUARTERS_REQUEST",
        value: payload,
      }),
    reduxPostHeadquarters: (payload) =>
      dispatch({
        type: "CREATE_HEADQUARTERS_REQUEST",
        value: payload,
      }),
    reduxGetHeadquarter: (payload) =>
      dispatch({
        type: "READ_HEADQUARTERS_REQUEST",
        value: payload,
      }),
    reduxDeleteHeadquarters: (payload) =>
      dispatch({
        type: "DELETE_HEADQUARTERS_REQUEST",
        value: payload,
      }),
    reduxPatchHeadquarters: (payload) =>
      dispatch({
        type: "UPDATE_HEADQUARTERS_REQUEST",
        value: payload,
      }),
    reduxResetHeadquartersForm: () =>
      dispatch({
        type: "RESET_HEADQUARTERS_FORM",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Headquarters);
